/**
 * Paying for Pro, from the client (netlify/functions/api/pay.ts): ask for a payment request,
 * then ask whether the transfer has landed. No wallet is connected to the site; the person
 * pays from any wallet app, and the server credits the account once it sees the transfer.
 */
import { apiClient } from './apiClient';
import type { PaymentRequest, PaymentState } from './solanaPay';

/** A payment request for this many months of Pro */
export const createPaymentIntent = (credits: number): Promise<PaymentRequest> =>
    apiClient.post<PaymentRequest>('/pay/intent', { credits });

/** Whether the transfer for a request has landed; crediting happens on the server when it has */
export const checkPayment = (reference: string): Promise<PaymentState> =>
    apiClient.post<PaymentState>('/pay/check', { reference });

/** What an API refusal says, for the page */
export const paymentErrorText = (e: unknown, fallback: string): string => {
    const data = (e as { data?: { error?: unknown; message?: unknown } })?.data;
    const said = data?.error ?? data?.message ?? (e as { message?: unknown })?.message;
    return typeof said === 'string' && said && !/^Request failed/.test(said) ? said : fallback;
};
